import * as Styles from './UserInitials.styles';

export type UserInitialsProps = {
  initials: string;
  pictureUrl?: string;
  size?: number;
  title?: string;
  className?: string;
  fontSize?: number;
};

const UserInitials = function ({
  initials,
  pictureUrl,
  size,
  title,
  fontSize,
  ...props
}: UserInitialsProps): JSX.Element {
  return (
    <Styles.Box
      pictureUrl={pictureUrl}
      size={size}
      data-testid="user-initials"
      title={title}
      style={{ fontSize }}
      {...props}
    >
      {initials}
    </Styles.Box>
  );
};

export default UserInitials;
